export const GoogleMapApiConfig = "AIzaSyAe_YoK9Vru7a3yaNh53DQP1uTQosaX7vo";